import { useMassActivityExportForm } from '@/modules/activities/hooks'
import {
  ExportCard,
  ExportPeriodField,
} from '@/modules/exports/components/export-form'
import { useOnErrorAuto, useUser } from '@/utils/hooks'
import { useMutation } from '@apollo/client'
import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'

interface ExportActivityExceptionReportCardProps {
  header: string
  mutation: any
  resultKey: string
}

export const ExportActivityExceptionReportCard: React.FC<
  ExportActivityExceptionReportCardProps
> = ({ header, mutation, resultKey }) => {
  const me = useUser()
  const translations = useTranslate({
    error: 'error.generic-server-error',
    downloadSuccess: 'exports.success-user-exports',
  })
  const { loading, form, updateForm, getExportDateInterval } =
    useMassActivityExportForm()
  const onErrorAuto = useOnErrorAuto()
  const addToast = useToast()

  const [doExport] = useMutation(mutation, {
    onCompleted(data) {
      if (data?.[resultKey]?.ok) {
        addToast('success', translations.downloadSuccess)
      } else addToast('error', translations.error)
    },
    onError: onErrorAuto(translations.error),
  })

  function handleSubmit() {
    const [dateStart, dateEnd] = getExportDateInterval()
    void doExport({
      variables: {
        user: me.id,
        dateStart,
        dateEnd,
      },
    })
  }

  return (
    <ExportCard title={header} loading={loading} onSubmit={handleSubmit}>
      <ExportPeriodField
        value={form}
        wide
        onChange={value => updateForm(value)}
      />
    </ExportCard>
  )
}
